(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gng-audit-catalog"]) return;
  try {
    
(() => {
 const init = () => document.querySelectorAll('.gng-catalog').forEach(section => {
  const tools=section.querySelector('.gng-catalog-tools');
  if(!tools || tools.dataset.ready) return;
  tools.dataset.ready='true'; tools.hidden=false;
  const grid=section.querySelector('.gng-product-grid');
  const cards=Array.from(grid.querySelectorAll('.gng-card'));
  const family=tools.querySelector('[data-gng-family]');
  const budget=tools.querySelector('[data-gng-budget]');
  const sort=tools.querySelector('[data-gng-sort]');
  const initialBudget=new URLSearchParams(window.location.search).get('price');
  if(['5000','10000','10000-plus'].includes(initialBudget)) budget.value=initialBudget;
  const labels={boards:'Serving & charcuterie boards',signs:'Wood signs & plaques',slate:'Slate coaster sets',wine:'Wine gift boxes',ornaments:'Christmas ornaments',leds:'LED displays',accessories:'Accessories'};
  [...new Set(cards.map(c=>c.dataset.family).filter(Boolean))].forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=labels[value] || value;family.append(option);});
  const update=()=>{
   const sorted=[...cards];
   if(sort.value==='title') sorted.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));
   if(sort.value==='price-asc') sorted.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
   if(sort.value==='price-desc') sorted.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
   let count=0;
   sorted.forEach(card=>{card.hidden=Boolean((family.value && card.dataset.family!==family.value) || (budget.value && (budget.value==='10000-plus' ? Number(card.dataset.price)<10000 : Number(card.dataset.price)>=Number(budget.value))));if(!card.hidden)count++;grid.append(card);});
   tools.querySelector('.gng-result-count').textContent=count+' of '+cards.length+' products'+(budget.value?' · starting prices before tax and shipping':'');
   const empty=section.querySelector('.gng-no-results');if(empty)empty.hidden=count!==0;
  };
  tools.addEventListener('change',update);
  tools.querySelector('.gng-reset').addEventListener('click',()=>{family.value='';budget.value='';sort.value='featured';update();});
  update();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('#gngHeaderCart');
  if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const drawer = document.getElementById('ecxCartDrawer');
  if (!drawer || typeof drawer.openDrawer !== 'function') return;
  event.preventDefault();
  drawer.openDrawer(trigger);
});
const gngRefreshHeaderCartCount = function () {
  fetch(window.routes.cart_url + '.js').then(function (response) {
    if (!response.ok) throw new Error('Cart refresh failed');
    return response.json();
  }).then(function (cart) {
    const count = document.querySelector('#gngHeaderCart .js-cart-count-number');
    if (count) count.textContent = cart.item_count;
  }).catch(function () {});
};
document.addEventListener('cart:update', gngRefreshHeaderCartCount);
document.addEventListener('opening', function (event) {
  if (event.target.id === 'ecxCartDrawer') gngRefreshHeaderCartCount();
}, true);

  } catch(e) { console.error(e); }
})();
})();
